import { ModelBase } from 'store/model-base';

export interface AddRemoveAddonsOrders {
    lineIdKey: string;
    orderId: string;
}

export class AddonRequestStatus extends ModelBase {
    public static storeName: string = 'addonRequestStatus';

    public requestId: string;
    public overallStatus: string;
    public orders: AddonRequestStatus[];

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: AddonRequestStatus = super.create<AddonRequestStatus>(initData);
        
        return super.create<T>(toReturn);
    }
}
